import { NavLink } from 'react-router-dom';
import { auth } from '../config/firebase';

function Sidebar({ user }) {
  const handleLogout = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error("Logout error", error);
    }
  };

  const navItems = [
    { path: '/', label: 'Dashboard', icon: '📊' },
    { path: '/map', label: 'Mapa en Vivo', icon: '🗺️' },
    { path: '/trips', label: 'Viajes', icon: '🛵' },
    { path: '/drivers', label: 'Conductores', icon: '👤' },
    { path: '/users', label: 'Usuarios', icon: '👥' },
    { path: '/blocks', label: 'Bloqueos', icon: '🚫' },
    { path: '/analytics', label: 'Analíticas', icon: '📈' },
    { path: '/messages', label: 'Mensajes', icon: '📢' },
    { path: '/support', label: 'Soporte', icon: '💬' },
    { path: '/admins', label: 'Administradores', icon: '🛡️' },
    { path: '/settings', label: 'Configuración', icon: '⚙️' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src="/log_o.png" alt="Logo" style={{ height: '44px', objectFit: 'contain' }} />
          <span><span style={{color: '#FFD700'}}>Drai</span><span style={{color: '#ffffff'}}>Ven</span></span>
        </div>
        <p className="sidebar-tagline">Panel de Administración</p>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-link-icon">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">
            {user?.email?.charAt(0).toUpperCase() || 'A'}
          </div>
          <div className="sidebar-user-info">
            <p className="sidebar-user-email" title={user?.email}>{user?.email}</p>
            <p className="sidebar-user-role">Administrador</p>
          </div>
        </div>
        <button onClick={handleLogout} className="sidebar-logout">
          🚪 Cerrar Sesión
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
